import { trigger, state, style, transition, animate } from '@angular/animations';

export const DialogFadeAnimation = trigger('dialogFade', [
  state('open', style({
    opacity: 1,
    transform: 'translateY(0)'
  })),
  state('closed', style({
    opacity: 0,
    transform: 'translateY(150%)'
  })),
  transition('closed => open', [
    animate('0.4s ease-in')
  ]),
  transition('open => closed', [
    animate('0.4s ease-out')
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/dialog-fade.animation.ts